import axios from "./request";
export default {
  // queryPageList: (params = {}) => axios.post("/publicityImg/pageList", params),
  queryDetail: (params = {}) => axios.post("/xxszxc/qyly/detail/" + params.id, params),
  queryPageList: (params = {}) => axios.post("/xxszxc/qyly/pageList", params),
};
